import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, getAuthHeader } from '../utils/config';

const usePushNotifications = () => {
  const [permission, setPermission] = useState(Notification.permission);
  const [subscribed, setSubscribed] = useState(false);

  const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
  };

  const subscribe = async () => {
    try {
      // Request permission
      const perm = await Notification.requestPermission();
      setPermission(perm);
      if (perm !== 'granted') return;

      // Register service worker
      const reg = await navigator.serviceWorker.register('/sw.js');
      await navigator.serviceWorker.ready;

      // Get VAPID key
      const { data } = await axios.get(`${API_URL}/notifications/vapid-key`);

      // Subscribe to push
      const subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.publicKey)
      });

      // Save subscription to backend
      await axios.post(`${API_URL}/notifications/subscribe`,
        { subscription },
        { headers: getAuthHeader() }
      );

      setSubscribed(true);
      console.log('✅ Push notifications enabled');
    } catch (err) {
      console.error('Push subscription failed:', err);
    }
  };

  const unsubscribe = async () => {
    try {
      await axios.delete(`${API_URL}/notifications/unsubscribe`, { headers: getAuthHeader() });
      const reg = await navigator.serviceWorker.getRegistration();
      if (reg) {
        const sub = await reg.pushManager.getSubscription();
        if (sub) await sub.unsubscribe();
      }
      setSubscribed(false);
    } catch (err) {
      console.error('Unsubscribe failed:', err);
    }
  };

  useEffect(() => {
    // Auto-subscribe if permission already granted
    if (Notification.permission === 'granted' && 'serviceWorker' in navigator) {
      subscribe();
    }
  }, []);

  return { permission, subscribed, subscribe, unsubscribe };
};

export default usePushNotifications;
